export enum PackageAcquisitionLocation {
    Server = "Server",
    ExecutionTarget = "ExecutionTarget",
    NotAcquired = "NotAcquired"
}
